document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.card-wrapper').forEach(card => {
    const hiddenInput = card.querySelector('input[name="id"]');
    const cardLink = card.querySelectorAll('a');
    let matchID;
    if (!hiddenInput) return;

    card.querySelectorAll('variant-selects input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', () => {
        let images = card.querySelectorAll('.card__media .media img.variants-media');
        console.log(images.length)
        if (images.length > 0) {
          images.forEach((img) => img.classList.remove('active')) 
        }
        let addToCartButtons = card.querySelectorAll('.quick-add__submit');
        addToCartButtons.forEach((btn) => btn.classList.add('hidden'))
        const dataScript = card.querySelector('variant-selects script[type="application/json"]');
        if (!dataScript) return;
        const variants = JSON.parse(dataScript.textContent);
        const selectedOpts = Array.from(
          card.querySelectorAll('fieldset input[type="radio"]:checked')
        ).map(r => r.value);

        const match = variants.find(v =>
          JSON.stringify(v.options) === JSON.stringify(selectedOpts)
        );
        if (match) {
          hiddenInput.value = match.id;
          cardLink.forEach(a => {
            const param = '?variant=' + match.id;
            if (!a.href.includes(param)) {
              a.href = card.dataset.baseUrl + param;
            }
          });
        matchID = match.id;
        if (images.length > 0) {
         card.querySelector('img[data-variant-id="' + matchID + '"]').classList.add('active'); 
        }
        card.querySelector('.quick-add__submit[data-variant-id="' + matchID + '"]').classList.remove('hidden');
        }
      });
    });
  });
});